import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { ClientSurveyContactHistoryModel, ClientSurveyContactModel } from '../../../api/models';
import {
  SurveyContactHistoryService,
  SurveyContactService,
} from '../../../api/services';
import { AccountInfoService } from '../../../services/account-info.service';
import { ToastService } from '../../../services/toast.service';
import { BaseAccountInfoComponent } from '../../BaseAccountInfo/BaseAccountInfo.component';
import { DeleteSurveyContactHistoryAsync$Json$Params } from '../../../api/fn/survey-contact-history/delete-survey-contact-history-async-json';

@Component({
  selector: 'app-contact-history-grid',
  templateUrl: './contact-history-grid.component.html',
  styleUrls: ['./contact-history-grid.component.scss'],
})
export class ContactHistoryGridComponent
  extends BaseAccountInfoComponent
  implements OnInit
{
  @Input() matterId: number;
  @Input() surveyTypeId: number;
  @Input() month: number;
  @Input() year: number;
  @Output() outputSurveyContact: EventEmitter<ClientSurveyContactModel> =
    new EventEmitter<ClientSurveyContactModel>();

  surveyContact: ClientSurveyContactModel;

  faCircleNotch = faCircleNotch;
  areContactsLoading = false;
  areContactsError = false;

  constructor(
    private toastService: ToastService,
    private surveyContactService: SurveyContactService,
    private surveyContactHistoryService: SurveyContactHistoryService,
    protected override accountInfoService: AccountInfoService
  ) {
    super(accountInfoService);
  }

  override ngOnInit() {
    super.ngOnInit();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['matterId'] || changes['surveyTypeId']) {
      if (
        this.accountInfo?.isLoaded &&
        this.matterId !== undefined &&
        this.surveyTypeId !== undefined
      ) {
        this.getSurveyContact();
      }
    }

    // Trigger a function when accountInfo is fully loaded
    this.accountInfoService.accountInfo$.subscribe((accountInfo) => {
      if (accountInfo?.isLoaded) {
        this.accountInfo = accountInfo; // Set the accountInfo in the base class
        this.getSurveyContact(); // Call the function when accountInfo is loaded
      }
    });
  }

  getSurveyContact() {
    if (this.areContactsLoading) return; // Prevent multiple calls
    this.areContactsLoading = true;
    this.areContactsError = false;
    this.surveyContactService
      .getSurveyContactAsync$Json$Response({
        repId: this.accountInfo?.isAdmin ? undefined : this.accountInfo!.repId!,
        surveyTypeId: this.surveyTypeId,
        caseId: this.matterId,
        month: this.month,
        year: this.year,
      })
      .subscribe({
        next: (r) => {
          this.areContactsLoading = false;
          if (!r.body) {
            this.areContactsError = true;
            this.outputSurveyContact.emit(r.body);
          } else {
            this.surveyContact = r.body;
            this.outputSurveyContact.emit(this.surveyContact);
            this.surveyContact.contactHistories =
              this.surveyContact.contactHistories!.reverse();

            //this.getSurveyContactHistories();
          }
        },
        error: (error) => {
          console.error(error, this);
          this.areContactsError = true;
          this.areContactsLoading = false;
          this.toastService.showToast(
            'danger',
            'Problem loading survey contact'
          );
        },
      });
  }

  getSurveyContactHistories() {
    this.surveyContactHistoryService
      .getSurveyContactHistoriesAsync$Json$Response({
        surveyContactId: this.surveyContact?.surveyContactId,
      })
      .subscribe({
        next: (r) => {
          if (!r.body) {
            this.toastService.showToast(
              'danger',
              'Problem loading survey contact histories'
            );
          } else {
            this.surveyContact.contactHistories = r.body.reverse();
          }
        },
        error: (error) => {
          console.error(error, this);
          this.toastService.showToast(
            'danger',
            'Problem loading survey contact histories'
          );
        },
      });
  }

  deleteSurveyContactHistory(m: ClientSurveyContactHistoryModel) {
    let deleteparams: DeleteSurveyContactHistoryAsync$Json$Params = {
      surveyContactHistoryId: m.surveyContactHistoryId!
    };
    this.surveyContactHistoryService.deleteSurveyContactHistoryAsync$Json$Response(deleteparams).subscribe({
      next: (response) => {
        if (!response.body) {
          this.toastService.showToast('danger', 'Problem deleting survey contact history');
        }
        else {
          this.toastService.showToast('success', 'Survey Contact History deleted successfully');
          this.getSurveyContactHistories();
        }
      },
      error: (e) => {
          console.error(e, this);
          this.toastService.showToast(
            'danger',
            'Problem deleting survey contact history'
          );
      }
    });
  }
}
